import { Pencil, X } from "lucide-react";
import { ShareholderFormData } from "./share-holder-modal";



export default function ShareholderList({ shareholders, onEdit, onRemove, showPosition = false, showActionButtons = true }: {
    shareholders: any[];
    onEdit: (shareholder: ShareholderFormData) => void;
    onRemove: (shareholder: ShareholderFormData) => void;
    showPosition?: boolean,
    showActionButtons?: boolean
}) {
    const getInitials = (firstName: string, lastName: string) => {
        return (firstName?.[0] + lastName?.[0] || "").toUpperCase();
    };

    const formatName = (salutation: string, firstName: string, middleName: string, lastName: string) => {
        const formattedSalutation = salutation?.toUpperCase() || "";
        return `${formattedSalutation}. ${firstName} ${middleName} ${lastName}`.trim();
    };

    if (!shareholders || shareholders.length === 0) {
        return null;
    }
    
    return (
        <div className={`w-full space-y-3 ${showActionButtons && "grid grid-cols-2 gap-4"}`} >
            {shareholders.map((shareholder:any) => (
                <div key={shareholder.salutation} className="flex items-center justify-between p-6 bg-white rounded-xl shadow-sm border  border-gray-100">
                    <div className="flex items-center gap-4">
                        <div className="w-11 h-11 rounded-full bg-gray-100 flex items-center justify-center">
                            <span className="text-sm text-orange-500 font-medium">
                                {getInitials(shareholder.firstName, shareholder.lastName)}
                            </span>
                        </div>
                        <div className="space-y-1">
                            <h3 className="text-sm font-bold text-[#48505E]">
                                {formatName(
                                    shareholder.salutation,
                                    shareholder.firstName,
                                    shareholder.middleName,
                                    shareholder.lastName
                                )}
                            </h3>
                            <div className="flex gap-4 text-sm text-gray-500">
                                {showPosition ? <span>{shareholder.shareholderPosition}</span> : <span>{shareholder.nationality}</span>}
                                {!showPosition &&  <span>.</span>}
                                {!showPosition &&  <span>{shareholder.numberOfShares} shares</span>}
                               
                            </div>
                        </div>
                    </div>

                    {
                        showActionButtons && (
                            <div className="flex items-center gap-4">
                                <button
                                    type="button"
                                    onClick={() => onEdit(shareholder)}
                                    className="p-2 hover:bg-gray-50 rounded-lg transition-colors"
                                >
                                    <Pencil size={20} className="text-gray-600" />
                                </button>
                                <button
                                        type="button"
                                         onClick={(e) => {
                                            e.stopPropagation();
                                            onRemove(shareholder);
                                        }}
                                    className="p-2 hover:bg-gray-50 rounded-lg transition-colors"
                                >
                                    <X size={20} className="text-gray-600" />
                                </button>
                        </div>
                        )
                    }
               
                </div>
            ))}
        </div>
    );
}